import { THEME } from '@Theme';
import { StyleSheet } from 'aphrodite';
import { BreakPoints, BrowserMediaQueries } from '../../styles/styles';

export const AppBarHeight = 100;

const searchSectionHeight = 60;
const tabsSectionHeight = 48;
const searchSectionTopMargin = 20;

const {
	colors,
	common: { borderRadius },
	spacing: { sm, md, lg },
} = THEME;

export const styleSheet = StyleSheet.create({
	arrowContainer: {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'center',
		padding: '1rem',
		pointerEvents: 'none',
		position: 'absolute',
		top: '50%',
		transform: 'translateY(-50%)',
	},
	arrowLeft: {
		cursor: 'pointer',
		pointerEvents: 'auto',
		transform: 'rotate3d(0,0,1,90deg)',
	},
	arrowLeftContainer: {
		backgroundImage: 'linear-gradient(to left, rgba(249,249,249, 0), rgba(249,249,249, 1) 90%)',
		left: 0,
		paddingRight: '2rem',
	},
	arrowRight: {
		cursor: 'pointer',
		pointerEvents: 'auto',
		transform: 'rotate3d(0,0,1,-90deg)',
	},
	arrowRightContainer: {
		backgroundImage: 'linear-gradient(to right, rgba(249,249,249, 0), rgba(249,249,249, 1) 50%)',
		paddingLeft: '2rem',
		right: 0,
	},
	browse: {
		fontSize: 14,
		margin: '0 10px 0 0',
		[BreakPoints.forMaxWidth(840)]: {
			color: 'transparent',
			width: 0,
		},
	},
	browseAllCampaigns: {
		cursor: 'pointer',
		marginRight: 10,
		marginTop: 0,
		textAlign: 'right',
	},
	clearSearch: {
		marginLeft: 10,
		marginRight: 20,
		whiteSpace: 'nowrap',
	},
	containerComponent: {
		boxSizing: 'border-box',
		display: 'flex',
		flex: 1,
		flexDirection: 'column',
		width: '100%',
	},
	dropdownTrigger: {
		width: 180,
		backgroundColor: colors.background.light,
	},
	flexDiv: {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'space-between',
	},
	hideGradient: {
		width: 0,
	},
	htmlNewsletterTab: {
		border: `1px solid #C75DA6`,
		borderRadius: 3,
		boxSizing: 'border-box',
		flexShrink: 0,
		padding: '5px 10px',
	},
	myTemplatesHighlight: {
		border: `1px solid ${colors.success.main}`,
		borderRadius,
	},
	industryDropdown: {
		alignItems: 'center',
		display: 'flex',
		marginLeft: 10,
	},
	industrySection: {
		alignItems: 'center',
		display: 'flex',
		height: 40,
		margin: '0 14px 0 0',
		gap: md,
	},
	loadingContainer: {
		marginTop: 30,
	},
	reviewed: {
		color: '#89C947',
		marginLeft: 5,
	},
	searchBoxInput: {
		minWidth: 280,
	},
	searchResults: {
		alignItems: 'center',
		display: 'flex',
		fontSize: 14,
		height: 37,
		paddingBottom: 10,
		paddingTop: 10,
		width: '100%',
	},
	searchSection: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		overflow: 'hidden',
		boxSizing: 'border-box',
		justifyContent: 'space-between',
		marginTop: searchSectionTopMargin,
		maxHeight: searchSectionHeight,
		whiteSpace: 'nowrap',
	},
	socialMediaTab: {
		border: `1px solid #046cb6`,
		borderRadius: 3,
		boxSizing: 'border-box',
		flexShrink: 0,
		padding: '5px 10px',
	},
	tab: {
		alignItems: 'center',
		boxSizing: 'border-box',
		cursor: 'pointer',
		display: 'flex',
		flexShrink: 0,
		fontSize: 12,
		justifyContent: 'center',
		letterSpacing: 1.05,
		textTransform: 'uppercase',
		whiteSpace: 'nowrap',
		padding: `${md}px ${md}px ${sm}px`,
		color: colors.text.light,
	},
	tabNavigation: {
		alignItems: 'center',
		borderBottom: `1px solid ${colors.border.light}`,
		display: 'flex',
		height: tabsSectionHeight,
		justifyContent: 'space-between',
		position: 'relative',
	},
	tabSection: {
		'::-webkit-scrollbar': {
			display: 'none',
		},
		alignItems: 'center',
		[BrowserMediaQueries.IE11]: {
			overflowX: 'auto',
			padding: '30px 10px 0px',
		},
		display: 'flex',
		overflowStyle: 'none',
		overflowX: 'scroll',
		scrollbarWidth: 'none',
	},
	tabSelected: {
		color: colors.primary.main,
	},
	placeholder: {
		marginTop: lg,
		width: '100%',
	},
	rowLayout: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		overflow: 'hidden',
		boxSizing: 'border-box',
	},
	rightAlign: {
		display: 'flex',
		justifyContent: 'flex-end',
		alignItems: 'center',
		overflow: 'hidden',
		boxSizing: 'border-box',
		width: '100%',
	},
});
